import overall from "./overall";
import properties from "./properties";
import clients from "./clients";

export default {
  overall,
  properties,
  clients,
};
